import React from "react";

export type LayoutContextType = {
  headerIsShown: boolean;
};

export const LayoutContext = React.createContext<LayoutContextType>({
  headerIsShown: false,
});

export function useLayoutContext(): LayoutContextType {
  return React.useContext(LayoutContext);
}
